import amexIcon from '../assets/amex.svg';
import dinersClubIcon from '../assets/dinersclub.svg';
import discoverIcon from '../assets/discover.svg';
import jcbIcon from '../assets/jcb.svg';
import mastercardIcon from '../assets/mastercard.svg';
import unionpayIcon from '../assets/unionpay.svg';
import visaIcon from '../assets/visa.svg';

export const getCreditCardIcon = (cardType) => {
  switch (cardType) {
    case 'visa':
      return visaIcon;
    case 'mastercard':
      return mastercardIcon;
    case 'discover':
      return discoverIcon;
    case 'amex':
      return amexIcon;
    case 'jcb':
      return jcbIcon;
    case 'diners':
      return dinersClubIcon;
    case 'unionpay':
      return unionpayIcon;
    default:
      // TODO handle unknown card type icons
      return '';
  }
};
